<template>
    <div class="carro carro-mini">
        <router-link to="/carro">        
            <img src="dist/img/shopping-cart.png" style="margin-right:5px;margin-top:5px; margin-bottom:5px"/>            
            <span v-if="cantidad>0" class="badge badge-primary badge-pill" style="position:relative;top:-20px;right:20px;">{{cantidad}}</span>
        </router-link>
    </div>
</template>
<script>

export default {
    data() {
        
    },
    computed:{
        cantidad() {
            return this.$store.getters["getTotal"];
        }
    },
    mounted() {
    this.$store.commit("loadFromLocalStorage");
  }
}
</script>
